let unlocked = false;
const cache = {};
let vibrateTimer = null;

// Observable state for QA/automation (audio elements are not in the DOM).
const state = { ringtone: "stopped", dialtone: "stopped", end: "stopped", vibrating: false, unlocked: false };
const publish = () => {
  window.__callSound = { ...state };
};
publish();

const el = (name, loop) => {
  if (!cache[name]) {
    const audio = new Audio(`/sounds/${name}.mp3`);
    audio.loop = loop;
    audio.preload = "auto";
    cache[name] = audio;
  }
  return cache[name];
};

export const unlockAudio = () => {
  if (unlocked) return;
  unlocked = true;
  state.unlocked = true;
  publish();
  ["ringtone", "dialtone", "end"].forEach((name) => {
    const audio = el(name, name !== "end");
    const wasMuted = audio.muted;
    audio.muted = true;
    audio
      .play()
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
        audio.muted = wasMuted;
      })
      .catch(() => {
        audio.muted = wasMuted;
      });
  });
};

export const playLoop = (name) => {
  const audio = el(name, true);
  audio.currentTime = 0;
  state[name] = "playing";
  publish();
  audio.play().catch(() => {});
};

export const stopLoop = (name) => {
  state[name] = "stopped";
  publish();
  const audio = cache[name];
  if (!audio) return;
  audio.pause();
  audio.currentTime = 0;
};

export const playOnce = (name) => {
  const audio = el(name, false);
  audio.currentTime = 0;
  state[name] = "played";
  publish();
  audio.play().catch(() => {});
};

export const startVibration = (pattern = [600, 400]) => {
  stopVibration();
  if (!navigator.vibrate) return;
  state.vibrating = true;
  publish();
  navigator.vibrate(pattern);
  const period = pattern.reduce((a, b) => a + b, 0);
  vibrateTimer = setInterval(() => navigator.vibrate(pattern), period);
};

export function stopVibration() {
  state.vibrating = false;
  publish();
  if (vibrateTimer) {
    clearInterval(vibrateTimer);
    vibrateTimer = null;
  }
  if (navigator.vibrate) navigator.vibrate(0);
}

export const stopAllCallSounds = () => {
  stopLoop("ringtone");
  stopLoop("dialtone");
  stopVibration();
};
